import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

type Ratio = keyof typeof CLASS_MAP;

const CLASS_MAP = {
  '1x1': 'ratio-1x1',
  '3x2': 'ratio-3x2',
  '4x3': 'ratio-4x3',
  '16x9': 'ratio-16x9',
} as const;

@Component({
  selector: 'lui-image',
  template: '<img *ngIf="src" [attr.src]="src" [alt]="alt"  />',
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageComponent {
  @Input() src!: string;
  @Input() alt!: string;
  @Input() ratio: Ratio = '1x1';
  @Input() priority: string | boolean | undefined;

  @HostBinding('class') get hostClasses() {
    return ['lui-image', 'ratio', CLASS_MAP[this.ratio] as string];
  }
}
